import React, { useEffect, useState } from "react";
import "../../styles/Industries.css";
import { RiArrowRightSLine } from "react-icons/ri";
 import Fintech_bg_img from "../../bg_images/I_fintech_bg_img.png";
import { useNavigate } from "react-router-dom";
import { MdArrowRightAlt } from "react-icons/md";
import { HiArrowNarrowRight } from "react-icons/hi";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";


const Servicecards = [
  {
    title: "Legacy Systems Slow Innovation",
    text: "Our fintech IT solutions modernize systems, creating scalable, secure platforms that enable rapid innovation. ",
  },
  {
    title: " Balancing Costs and Efficiency ",
    text: " With customized fintech IT consulting, we design cost-effective strategies that deliver measurable ROI and operational efficiency. ",
  },
  {
    title: "Ensuring Compliance in a Dynamic Landscape",
    text: " We deliver fintech IT services that simplify compliance while protecting sensitive data. ",
  },
  {
    title: " Managing Data Security Risks ",
    text: " Data breaches erode trust and incur significant losses. Our fintech IT infrastructure prioritizes security, offering robust safeguards to protect your business and customers. ",
  },
  {
    title: " Scaling for Growth Without Disruption ",
    text: " Expanding operations often leads to bottlenecks and inefficiencies. Our scalable IT infrastructure supports seamless growth, keeping your systems optimized and future-ready.",
  },
];


const Fintech = () => {
  const navigate = useNavigate();
  
  const [currentIndex, setCurrentIndex] = useState(0);
    const [visibleServicecards, setVisibleServicecards] = useState(3);
  
    
    useEffect(() => {
      const updateVisibleServicecards = () => {
        if (window.innerWidth <= 768) {
          setVisibleServicecards(1); 
        } else {
          setVisibleServicecards(3); 
        }
      };
  
      updateVisibleServicecards();
      window.addEventListener("resize", updateVisibleServicecards);
      return () =>
        window.removeEventListener("resize", updateVisibleServicecards);
    }, []);
  
    const handleNext = () => {
      if (currentIndex + visibleServicecards < Servicecards.length) {
        setCurrentIndex(currentIndex + 1);
      }
    };
  
    const handlePrev = () => {
      if (currentIndex > 0) {
        setCurrentIndex(currentIndex - 1);
      }
    };
  

  return (
    <div className="Industries">
      <div
        className="I_sec1"
        style={{ backgroundImage: `url(${Fintech_bg_img})` }}
      >
        <h5>
          Industries <RiArrowRightSLine className="servrighticon" /> Fintech
        </h5>
        <h1> Fintech Solutions That Empower Business Leaders </h1>
        <p>
          Arshil delivers secure, scalable IT solutions tailored to the
          financial sector, helping leaders optimize operations, enhance
          compliance, and achieve measurable results.
        </p>
        <button
          onClick={() => navigate("/services/ApplicationDevelopment")}
          className="S_sec1_btn1"
        >
          Discover Our Solutions
          <HiArrowNarrowRight className="psec1arrow" />
        </button>
      </div>

      {/* Section 2 */}

      <div className="I_sec2">
        <h2>How We Empower Fintech Businesses</h2>
        <section className="I_sec2_cardsContainer">
          <section className="I_sec2_cards">
            <h6>
              <img
                className="I_sec2_icon"
                src="../svg/I_fin_sec2_img1.svg"
                alt=""
              />
              Custom IT Infrastrucutre
            </h6>
            <p>
              Scalable solutions built to enhance operational efficiency and
              manage costs.
            </p>
          </section>
          <section className="I_sec2_cards">
            <h6>
              <img
                className="I_sec2_icon"
                src="../svg/I_fin_sec2_img2.svg"
                alt=""
              />
              Compliance-focused IT COnsulting
            </h6>
            <p>
              Stay ahead of regulations with expert guidance tailored for the
              financial industry.
            </p>
          </section>
          <section className="I_sec2_cards">
            <h6>
              <img
                className="I_sec2_icon"
                src="../svg/I_fin_sec2_img3.svg"
                alt=""
              />
              Cloud Integration Services
            </h6>
            <p>Secure, agile cloud-based solutions for optimized workflows.</p>
          </section>
          <section className="I_sec2_cards">
            <h6>
              <img
                className="I_sec2_icon"
                src="../svg/I_fin_sec2_img4.svg"
                alt=""
              />
              IT Support for Scalability
            </h6>
            <p>Reliable support designed for dynamic business environments.</p>
          </section>
        </section>
        <button onClick={() => navigate("/contact")} className="I_sec2_btn1">
          Schedule a free consultation
          <HiArrowNarrowRight className="psec1arrow" />
        </button>
      </div>

      {/* Section 3 */}

      <div className="S_carousel-container">
        <h2 className="S_carousel-title">
          Solving the Key Challenges in Fintech
        </h2>
        <div className="S_carousel-wrapper">
          <button
            className="arrow left-arrow"
            onClick={handlePrev}
            disabled={currentIndex === 0}
          >
            <MdOutlineKeyboardArrowLeft className="S_rightArrow" />
          </button>

          <div className="S_carousel">
            <div
              className="S_carousel-track"
              style={{
                transform: `translateX(-${
                  currentIndex * (100 / visibleServicecards)
                }%)`,
              }}
            >
              {Servicecards.map((card, index) => (
                <div className="S_carousel-card" key={index}>
                  <h3>{card.title}</h3>
                  <div className="underline"></div>
                  <p>{card.text}</p>
                </div>
              ))}
            </div>
          </div>

          <button
            className="arrow right-arrow"
            onClick={handleNext}
            disabled={currentIndex + visibleServicecards >= Servicecards.length}
          >
            <MdOutlineKeyboardArrowRight className="S_rightArrow" />
          </button>
        </div>
      </div>

      {/* Section 4 */}

      <div className="I_sec4">
        <section className="I_sec4_left">
          <h1>Case Study</h1>
          <h6>Ensuring Success For Our Fintech Customers</h6>
          <p>
            We took our US-based FinFed Client from a promising proof of concept
            to a fully operational, cloud-native solution, using cutting-edge
            cloud technologies to ensure scalability and security at every
            level.
          </p>
          {/* <p>
            Read more about how we made this transition seamless and successful.
          </p> */}
        </section>
        <section className="I_sec4_right">
          <img
            className="I_sec4_img1"
            src="../images/I_fintech_img.png"
            alt="fintech"
          />
        </section>
      </div>

      {/* Section 5  */}

      <div className="I_sec5">
        <section className="I_sec5_left">
          <h4>Ready to Lead the Future of Fintech?</h4>
          <p>
            Let's discuss how we can help you build the next generation of
            financial technology. Contact us today to explore your project.
          </p>
        </section>
        <section className="I_sec5_right">
          <button onClick={() => navigate("/contact")}>
            Speak to Our Team Today
            <MdArrowRightAlt className="I_sec5_arrow_right" />
          </button>
        </section>
      </div>
    </div>
  );
};

export default Fintech;
